module.exports = __webpack_public_path__ + "static/img/logo.b6f108c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/logo.png
// module id = 5pHL
// module chunks = 0